import xmlFormat from 'xml-formatter';

export function looksLikeXml(str: unknown): str is string {
  if (typeof str !== 'string') return false;
  const trimmed = str.trim();
  return (
    trimmed.startsWith('<?xml') ||
    (trimmed.startsWith('<') && /^<[A-Za-z_][\w.-]*[\s>]/.test(trimmed))
  );
}

export function formatXml(xmlString: string): string {
  try {
    return xmlFormat(xmlString, { indentation: '  ', lineSeparator: '\n' });
  } catch {
    return xmlString;
  }
}

export function extractXmlPayloadSections(
  parsed: Record<string, unknown>
): Array<{ key: string; label: string; xml: string }> {
  const sections: Array<{ key: string; label: string; xml: string }> = [];
  const labelMap: Record<string, string> = {
    RequestPayload: 'Request',
    Request: 'Request',
    ResponseBody: 'Response',
    ResponsePayload: 'Response',
    Response: 'Response',
    RequestBody: 'Request Body',
  };

  for (const [key, value] of Object.entries(parsed)) {
    if (looksLikeXml(value)) {
      sections.push({
        key,
        label: labelMap[key] ?? key,
        xml: value as string,
      });
    }
  }

  return sections;
}
